import { render, staticRenderFns } from "./DeliveryNoticeList.vue?vue&type=template&id=6917da48&"
import script from "./DeliveryNoticeList.vue?vue&type=script&lang=js&"
export * from "./DeliveryNoticeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports